import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

export function maxItemsValidator(
  control: AbstractControl,
  field: FormlyFieldConfig,
): { [key: string]: unknown } | null {
  if (!control.value) {
    return null;
  }
  const delimiter = field.props['delimiter'] || ',';
  const items = control.value
    .split(delimiter)
    .map((item: string) => item.trim())
    .filter((i: string) => !!i);
  const max = field.props['maxItems'];
  if (max && items.length > max) {
    return { maxItems: { message: `Too many IDs provided. The maximum allowed is ${max}.` } };
  }
  return null;
}

export function delimiterValidator(
  control: AbstractControl,
  field: FormlyFieldConfig,
): { [key: string]: unknown } | null {
  if (!control.value) {
    return null;
  }
  const delimiter = field.props['delimiter'] || ',';
  const forbiddenDelimiters = [',', ';', '.', '|', '/', '\\', ' ', '\n', '\r', '\t', '-'].filter(
    (d) => d !== delimiter,
  );
  const containsForbiddenDelimiter = !!forbiddenDelimiters.find((forbiddenDelimiter) =>
    control.value.includes(forbiddenDelimiter),
  );
  if (containsForbiddenDelimiter) {
    return {
      delimiter: {
        message: `Invalid delimiter detected. Please use '${delimiter}' as the separator.`,
      },
    };
  }
  return null;
}

export function delimitedIdsPatternValidator(
  control: AbstractControl,
  field: FormlyFieldConfig,
): { [key: string]: unknown } | null {
  if (!control.value) {
    return null;
  }
  const delimiter = field.props['delimiter'] || ',';
  const regex = makeRegex(delimiter);
  return regex.test(control.value)
    ? null
    : {
        pattern: {
          message: `The input format is invalid. Please check that all IDs are correct and separated by '${delimiter}'`,
        },
      };
}

function escapeRegexChar(char: string): string {
  return char.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function makeRegex(delimiter: string): RegExp {
  const escapedDelimiter = escapeRegexChar(delimiter);
  return new RegExp(`^(?:\\d{5,6}${escapedDelimiter})*\\d{5,6}$`);
}
